import _ from 'lodash';

export const addLinkTestId = (prefixText: string, linkName: string): string => {
  return `${prefixText}-${_.camelCase(linkName)}`;
};
